const otpVerificationCodeEntryTemplate = `
<pwr-otp-identity-verification-code-entry-component 
    options="ctrl.options" 
    noCodeFunction="ctrl.openOTPNoCodeModal"
></pwr-otp-identity-verification-code-entry-component>
`;
export default otpVerificationCodeEntryTemplate;